import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import Product from '@/models/product';
import apiClient from '@/apiClient';
import getPromotionsTransformer from '@/api/transformers/promotion/promotionsTransformer';
import {AxiosResponse} from 'axios';

export default {
  async fetchPromotions(): Promise<any> {
    return apiClient.get(
      '/promotion/buy-x-get-y/place',
      {
        transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
        transformResponse: getPromotionsTransformer(),
      }
    )
      .then(({ data }: AxiosResponse) => data);
  },
  async createBuyXGetY(promotion: any): Promise<any> {
    const necessaryProductIds = promotion.necessaryProducts.map((product: Product) => product.projectProduct && product.projectProduct.id);
    const receivedProductIds = promotion.receivedProducts.map((product: Product) => product.projectProduct && product.projectProduct.id);

    return apiClient.post('/promotion/buy-x-get-y', {
      id: promotion.id,
      placeIds: promotion.placeIds,
      necessaryProductIds,
      receivedProductIds,
      necessaryCount: promotion.necessaryCount,
      receivedCount: promotion.receivedCount,
      name: promotion.name,
      description: promotion.description,
      terms: promotion.terms,
      enabled: promotion.enabled,
    }, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async removeBuyXGetY(id: string): Promise<any> {
    return apiClient.delete(`/promotion/buy-x-get-y/${id}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
}

